import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import styles from "@/styles/TabMenu.module.scss";

function Menu({ element, text, link }) {
  return (
    <ActiveLink className={styles.menu} {...link}>
      {element || text}
    </ActiveLink>
  );
}

export default function TabMenu({ menus }) {
  return (
    <div className={styles.container}>
      <ScrollMenu>
        {menus.map((menu, i) => (
          <Menu key={`menu=${i}`} {...menu} />
        ))}
      </ScrollMenu>
    </div>
  );
}
